import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./core/router";
import "./style.css";
import Config from "./core/services/axios";
import { installPrimeVue } from "./core/plugins/primevue";
import { initializeContext } from "./core/router/authGuard";
import { setupRouterGuards } from "./core/router/setupRouterGuards";
import { installRouteLoadingSpinner } from "./core/router/loading.guard";
import { auth } from "./core/store/auth";

const pinia = createPinia();
const app = createApp(App);

app.provide("axios", Config);

installPrimeVue(app);
app.use(pinia);

initializeContext();

await auth.initialize();

app.use(router);

setupRouterGuards(router, pinia);
installRouteLoadingSpinner(router);

router
  .isReady()
  .then(() => app.mount("#app"))
  .catch((error) => {
    console.error("Router failed to initialize", error);
    app.mount("#app");
  });
